import { headerOr } from "routes/schedule/tasks/lib/header-or"

export function applyTaskListPayloadFilter(task, filter, payloadTasks) {
    const payload = payloadTasks?.[task.id]
    const taskWithPayload = payload ? { ...task, ...payload } : task
    return headerOr(filter)(taskWithPayload)
}
